export const MAX_LEAKS_PROCESSED_IN_BATCH = 30



// WEBPACK FOOTER //
// ./src/common/constants.js